<template>
  <LayoutDefault>
    <div
      class="container dark"
      id="change_password"
    >
      <section class="block" v-if="sendingLoading">
        <div class="container spinner" >
          <Spinner />
        </div>
      </section>
      <section class="block" style="padding: 3rem 0;" v-if="!sendingLoading">
        <h1>{{$t('change_password.title')}}</h1>
        <div v-if="success">
          <p class="success-message">
            {{$t('change_password.success')}}
          </p>
        </div>

        <div v-else>
          <p>
            {{$t('change_password.text_change_password')}}
          </p>
        </div>

        <button v-if="!success"
                    type="button"
                    class="change_password_button"
                    @click.prevent="recoverAttempt"
            >
                {{$t('change_password.button')}}
        </button>
        
        
      </section>
      <section class="block" style="display:flex;align-content: space-between;align-items: center;margin: 1rem auto;">
          <div style="flex:1;">
            <router-link
              class="support-link"
              :to="{name: 'support'}">
              {{ $t('zammad_support.link') }}
            </router-link>
          </div>
          <div>
            <a    
              @click="$router.back()" class="btn-go-back">&laquo; 
              {{ $t('dashboard.back') }}
            </a>
          </div>
        </section>
    </div>
  </LayoutDefault>
</template>
<script>
import LayoutDefault from "../layouts/LayoutDefault";
import Spinner from "../components/Spinner";

export default {
  components: {
    LayoutDefault,
    Spinner
  },
  data() {
    return {
      sendingLoading: false,
      success: false,
    };
  },
  methods: {
    recoverAttempt() {
      this.sendingLoading = true;
      this.success = false;

      //this.$http.post('auth/send_recover_email', { email: this.loginForm.email }).then(() => {
      this.$http.post('auth/send_recover_email').then(() => {
        this.sendingLoading = false;
        this.success = true;
      }).catch(() => {
        this.sendingLoading = false;
        this.success = true;
      });
    }
  },
}
</script>
<style scoped lang="scss">
@import '../styles/variables';
@import '../styles/classes';

#change_password {
  box-sizing: border-box;
  min-height: 500px;
  padding: 9px;


  & .spinner {
    align-items: center;
    display: flex;
    min-width: 300px;
    min-height: 300px;      
    justify-content: center;
  }
}

.change_password_button {
  box-sizing: border-box;
  background-color: var(--pallete_main_color);
  color: white;
  padding: 0.5rem;
  margin: 1rem 0 0.5rem 0;
}

.block {
  margin:0 auto;
  width: 75%;
  & .success-message {
    color: green;
    font-size: 1rem;
  }

  & .error-message {
    color: var(--pallete_main_color);
    font-size: 0.9rem;
    padding: 0.3rem;
  }
}

.support-link {
  &:hover {
    font-weight: bold;
  }
}

.btn-go-back {
  color: var(--pallete_main_color);
  &:hover {
    cursor: pointer;
    font-weight: bold;
  }
}
</style>